import React from 'react';
import {
  Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import { compactCurrencyAxis, currencyFormatter } from '../../utils/reportingUtils';
import { chartRows, formatCount, truncateLabel } from './attributionReportUtils';

const SERIES_COLOR = 'var(--sl-fg-brand, #1982C4)';

const TOOLTIP_CONTENT_STYLE = {
  background: 'var(--sl-bg-primary)',
  border: '1px solid var(--sl-border-secondary)',
  borderRadius: 8,
  fontSize: 12,
};

function AttributionChart({ rows, metric }) {
  const revenue = metric === 'revenue';
  const format = revenue ? (value) => currencyFormatter.format(value) : formatCount;
  const bars = chartRows(rows, metric);

  return (
    <ResponsiveContainer width="100%" height={Math.max(160, bars.length * 36 + 48)}>
      <BarChart data={bars} layout="vertical" margin={{ top: 0, right: 20, left: 10, bottom: 0 }}>
        <CartesianGrid horizontal={false} stroke="var(--sl-border-secondary)" strokeDasharray="3 3" />
        <XAxis type="number" tickFormatter={revenue ? compactCurrencyAxis : formatCount} tickLine={false} axisLine={false} fontSize={12} />
        <YAxis type="category" dataKey="label" tickFormatter={truncateLabel} tickLine={false} axisLine={false} width={150} interval={0} fontSize={12} />
        <Tooltip formatter={(value) => format(value)} contentStyle={TOOLTIP_CONTENT_STYLE} cursor={{ fill: 'var(--sl-bg-secondary)' }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="credited" name={revenue ? 'Credited revenue' : 'Credited tickets'} fill={SERIES_COLOR} radius={[0, 4, 4, 0]} />
        {revenue && <Bar dataKey="influenced" name="Influenced revenue" fill={SERIES_COLOR} fillOpacity={0.3} radius={[0, 4, 4, 0]} />}
      </BarChart>
    </ResponsiveContainer>
  );
}

export default AttributionChart;
